import { AdditionalExercise } from '../types';
import { AppState } from '../../rootReducer';
import { AdditionalExercisesState } from '../types';

export const getState = (state: AppState): AdditionalExercisesState => state.additionalExercisesReducer;

export const getAdditionalExercisesList = (state: AppState): AdditionalExercise[] =>
    state.additionalExercisesReducer.additionalExercises || [];

export const isLoading = (state: AppState): boolean => state.additionalExercisesReducer.isLoading;
